import React, { useEffect, useState } from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import { RouteProps } from 'react-router';
import { ThemeProvider } from '@material-ui/core/styles';

import { getBaseName, routes } from './config/router/routes';
import { getRouteComponent } from './config/router/router';
import { I18nextProvider } from 'react-i18next';
import i18n from './helpers/i18n';
import { urlLang } from './helpers/langHelper';
import { appTheme } from './styles/_theme/theme';
import { Provider } from 'react-redux';
import { configureStore } from './store';

function App() {
    const [ready, setReady] = useState<boolean>(false);

    const detectAppLanguage = () => {
        const language = urlLang();
        i18n.changeLanguage(language).then(() => {
            setReady(true);
        });
    };
    const mapRoutes = () =>
        routes.map((props: RouteProps, index: number) =>
            getRouteComponent(index, props)
        );
    useEffect(() => {
        detectAppLanguage();
    }, []);

    return (
        <>
            {ready && (
                <ThemeProvider theme={appTheme}>
                    <Provider store={configureStore()}>
                        <I18nextProvider i18n={i18n}>
                            <BrowserRouter basename={getBaseName()}>
                                <Switch>{mapRoutes()}</Switch>
                            </BrowserRouter>
                        </I18nextProvider>
                    </Provider>
                </ThemeProvider>
            )}
        </>
    );
}

export default App;
